export const codes = {
  en: 'en-EN',
  es: 'es-ES',
  fr: 'fr-FR',
  ru: 'ru-RU',
  ua: 'uk-UA',
  de: 'de-DE',
  brpt: 'pt-BR',
  it: 'it-IT',
  se: 'sv-SE',
  he: 'he-IL',
  ar: 'ar-SA',
  jp: 'ja-JP',
  tr: 'tr-TR',
  hi: 'hi-IN',
  nl: 'nl-NL',
  el: 'el-GR',
  pl: 'pl-PL',
  ro: 'ro-RO',
  sl: 'sl-SI',
  da: 'da-DK',
  vi: 'vi-VN',
  th: 'th-TH',
  cs: 'cs-CZ',
  no: 'no-NO',
  bg: 'bg-BG',
  id: 'id-ID',
  ms: 'ms-MY',
  fi: 'fi-FI',
  'zh-hk': 'zh-HK',
  'zh-cn': 'zh-CN',
  sk: 'sk-SK',
  hu: 'hu-HU',
  ko: 'ko-KR',
  mn: 'mn-MN',
  hr: 'hr-HR',
  fa: 'fa-IR',
  te: 'te-IN',
  ca: 'ca-ES',
  az: 'az-AZ'
}
